import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, ButtonElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components/BasicBlock";
import React from "react";

const defaultData: ElementDefinition<ButtonElement>["defaultData"] = {
  attributes: {
    align: "center",
    "background-color": "#414141",
    border: "none",
    "border-radius": "3px",
    color: "#ffffff",
    "font-family": "Arial",
    "font-size": "13px",
    "font-weight": "normal",
    "inner-padding": "10px 25px",

    "letter-spacing": "0px",
    "line-height": "120%",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    target: "_blank",
    "text-decoration": "none",
    "text-transform": "none",
    "vertical-align": "middle",
  },
  data: {},
};

export const Button = createBlock<ButtonElement>({
  get name() {
    return t("Button");
  },
  defaultData,
  type: BasicType.BUTTON,
  create: (payload) => {
    const defaultData: ButtonElement = {
      type: BasicType.BUTTON,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.BUTTON,
  render(params) {
    return <BasicBlock params={params} tag="mj-button" />;
  },
});
